import { ReactNode } from 'react';

import { Button, IconPlus } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

export type PageHeaderCreateButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: ReactNode;
  isVisuallyDisabled?: boolean;
  'aria-disabled'?: boolean;
  'data-testid'?: string;
  children?: ReactNode;
};

export const HeaderCreateButton = ({
  onClick,
  disabled,
  disabledReason,
  isVisuallyDisabled,
  'aria-disabled': ariaDisabled,
  children = 'Create',
  ...rest
}: PageHeaderCreateButtonProps) => {
  const showDisabledReason = Boolean(disabled && disabledReason);
  const button = (
    <Button
      variant="primary"
      onClick={ariaDisabled || showDisabledReason ? undefined : onClick}
      disabled={disabled && !showDisabledReason}
      isVisuallyDisabled={isVisuallyDisabled || showDisabledReason}
      aria-disabled={ariaDisabled || showDisabledReason}
      data-track-source-anchor="bcfe8ba20e;header-create-button" {...rest}
    >
      <IconPlus />
      {children}
    </Button>
  );

  if (!showDisabledReason) return button;

  return (
    <TooltipRoot>
      {button}
      <Tooltip>{disabledReason}</Tooltip>
    </TooltipRoot>
  );
};
